var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoleMaster(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70S0 38.66 0 0Z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(327 257)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c19.27-10.857 43.727-4.098 54.626 15.097 10.9 19.196 4.115 43.559-15.155 54.417l-1.236.701c-13.154 7.471-20.57 22.174-18.517 37.162a174.339 174.339 0 0 1 1.61 23.691c0 8.468-.611 16.793-1.789 24.934-2.175 15.025 5.3 29.812 18.502 37.309l1.43.813c19.27 10.857 26.055 35.22 15.155 54.416C43.727 267.735 19.27 274.494 0 263.637l-1.754-.996c-13.354-7.584-29.898-6.054-41.887 3.545A172.837 172.837 0 0 1-87.592 291.8c-14.2 5.666-23.58 19.328-23.58 34.617v.401c0 22.092-17.909 40-40 40s-40-17.908-40-40c0-15.359-9.465-29.068-23.759-34.687a172.792 172.792 0 0 1-44.442-25.679c-11.985-9.549-28.498-11.035-41.823-3.467l-1.147.652c-19.27 10.857-43.727 4.098-54.627-15.097-10.9-19.196-4.114-43.559 15.156-54.416l.321-.183c13.328-7.57 20.869-22.508 18.65-37.674a173.904 173.904 0 0 1-1.829-25.199c0-8.199.572-16.265 1.677-24.16 2.1-15.003-5.338-29.738-18.511-37.219l-.308-.175c-19.27-10.858-26.056-35.221-15.156-54.417C-346.07-4.098-321.614-10.857-302.344 0",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(407.172 125.182)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0c0 56.042 45.485 102 101.593 102h18.814C176.515 102 222 56.042 222 0",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(147 20)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleMaster);
export default __webpack_public_path__ + "static/media/role-master.c4d7ae3daac9f14b1d95be8b4c004e5a.svg";
export { ForwardRef as ReactComponent };